import React, { useContext } from "react";
import { ReactComponent as WarningSvg } from "../../svgs/warning.svg";
import { LogContent } from "../../helper/context";
import { useAuth } from "../../helper/auth";
import { useNavigate } from "react-router-dom";

const Modal = () => {
  const { displayMeta, setDisplayMeta } = useContext(LogContent);
  const auth = useAuth();
  const navigate = useNavigate();

  return (
    <div
      id="popup-modal"
      tabIndex="-1"
      className=" overflow-y-auto overflow-x-hidden fixed top-0  left-0 md:inset-0 h-screen w-screen  md:h-full"
    >
      <div
        className="bg-black h-screen w-screen fixed z-[10] opacity-20"
        onClick={() => {
          setDisplayMeta(!displayMeta);
        }}
      />
      <div className="flex justify-center items-center relative p-4 w-full h-full md:h-auto z-50 lg:h-screen">
        <div className="relative bg-white pb-12 rounded-2xl shadow  w-[95%] lg:w-[50%]">
          <div className="flex flex-col justify-between items-center px-5 mt-5 pb-3 ">
            <WarningSvg className="mt-16" />
            <h2 className="mt-16 text-[#212121] text-base lg:text-2xl font-semibold">
              Are you sure you want to leave?
            </h2>
            <div className="mt-16 flex items-center px-8 flex-col md:flex-row">
              <button
                type="button"
                className="text-white font-extrabold text-sm px-9 mb-4 md:mb-0 py-2 lg:px-14 lg:py-3 bg-pw-blue rounded-3xl hover:bg-cyan-500 lg:mr-12"
                onClick={() => {
                  setDisplayMeta(!displayMeta);
                }}
              >
                Cancel
                <span className="sr-only">Close modal</span>
              </button>
              <button
                type="button"
                className="text-pw-blue font-extrabold text-sm px-12 py-2 lg:px-14 lg:py-3 bg-white border-pw-blue border rounded-3xl hover:bg-slate-200"
                onClick={() => {
                  setDisplayMeta(!displayMeta);
                  auth.logout();
                  navigate("/");
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
